function hexToRgba(hex = '', a = 1) {
    hex = hex.replace(new RegExp('#', 'g'), '');

    if (hex.length < 4) {
        hex = hex.replace(new RegExp('.', 'g'), m => m.repeat(2));
    }

    const [r = 0, g = 0, b = 0] = hex
        .split(new RegExp('(..)', 'g'))
        .filter(Boolean)
        .map(c => parseInt(c, 16));

    return `rgba(${r}, ${g}, ${b}, ${a})`;
}

// TESTS
// console.log('--- TESTS: ƒ hexToRgba ---');
// console.log(
//     'Test 1: fff |',
//     `isOk = ${hexToRgba('fff') === 'rgba(255, 255, 255, 1)'}`,
//     hexToRgba('fff'),
//     'rgba(255, 255, 255, 1)',
// );
// console.log(
//     'Test 2: fab781 |',
//     `isOk = ${hexToRgba('fab781') === 'rgba(250, 183, 129, 1)'}`,
//     hexToRgba('fab781'),
//     'rgba(250, 183, 129, 1)',
// );
// console.log(
//     'Test 3: fab781 0.5 |',
//     `isOk = ${hexToRgba('fab781', 0.5) === 'rgba(250, 183, 129, 0.5)'}`,
//     hexToRgba('fab781', 0.5),
//     'rgba(250, 183, 129, 0.5)',
// );
// console.log(
//     'Test 4: #fab781 0.5 |',
//     `isOk = ${hexToRgba('#fab781', 0.5) === 'rgba(250, 183, 129, 0.5)'}`,
//     hexToRgba('#fab781', 0.5),
//     'rgba(250, 183, 129, 0.5)',
// );

export default hexToRgba;



/** WEBPACK FOOTER **
 ** ../src/widgets/helpers/hexToRgba.js
 **/